// Dekad naming — the pure part of the "My kind of day" month/part picker.
//
// Lives here rather than in src/client/myday.js because it is environment
// neutral and tested on its own; myday.ts around it is all DOM and
// localStorage, which the shared-code type-check passes would reject.

const pad2 = (n: number) => String(n).padStart(2, '0');

// A dekad as the plain MM-DD the API takes, named by its midpoint day. BOTH
// halves are padded: "early" midpoints on the 5th, and "07-5" is not a date
// the server accepts — it answers 400, which the UI could only report as a
// vague "try again".
export const DEKAD_MIDPOINTS = [5, 15, 25];

export function mdFor(month: number, part: number): string {
  return `${pad2(month)}-${pad2(DEKAD_MIDPOINTS[part - 1])}`;
}
